import React, { Component } from 'react'
import {
  Button,
  Card,
  Col,
  Comment,
  Form,
  Icon,
  Input,
  List,
  message,
  Popconfirm,
  Spin,
} from 'antd'
import { compose } from 'recompose'
import { get, pick } from 'lodash'
import Posts from '../../../api/Posts'
import { strVal } from '../../../modules/Utils'
import { streamUrl } from '../../../variables'
import Avatar2 from '../../../assets/img/avatar_2.png'
import Authentication from '../../../modules/Authentication'
import moment from 'moment'

const FormItem = Form.Item
const { TextArea } = Input

class Comments extends Component {
  auth = new Authentication()

  constructor(props) {
    super(props)
    this.state = { loading: false, fetching: false, comments: props.comments }
    this.api = new Posts()
  }

  fetch = async () => {
    this.setState({ fetching: true })
    const comments = await this.api.comments.list(get(this.props, 'post._key'))
    this.setState({ fetching: false, comments })
  }
  delete = async (comment) => {
    this.setState({ fetching: true })
    try {
      await this.api.comments.delete(pick(comment.comment, ['_key', '_rev', '_id']))
      this.fetch()
    } catch (error) {
      console.error(error)
      message.error(error.errorMessage)
    }
    this.setState({ fetching: false })
  }

  submit = async (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        try {
          this.setState({ loading: true })
          let comment = {
            topic: this.props.post._id,
            description: values.text,
          }
          await this.api.comments.create(comment)
          this.setState({
            loading: false,
          })
          this.props.form.resetFields()
          await this.fetch()
        } catch (err) {
          message.error(err.errorMessage)
        }
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { userID } = this.props
    const { comments } = this.state
    const formItemLayout = {
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 4,
          offset: 20,
        },
      },
    }

    return (
      <Card bordered={false}>
        <Spin spinning={this.state.fetching}>
          {/*<div>*/}
          {/*{comments.map((c, i) => (*/}
          {/*<CommentView*/}
          {/*key={i}*/}
          {/*fetch={this.fetch}*/}
          {/*comment={c}*/}
          {/*userID={userID}*/}
          {/*/>*/}
          {/*))}*/}
          {/*</div>*/}
          {comments.length > 0 && (
            <List
              className="comment-list"
              header={`${comments.length} replies`}
              itemLayout="horizontal"
              dataSource={comments}
              renderItem={(cmt) => (
                <Comment
                  actions={
                    userID === get(cmt, 'owner._id') && [
                      <Popconfirm
                        title="Are you sure delete this Comment?"
                        onConfirm={() => this.delete(cmt)}
                        okText="Yes"
                        cancelText="No">
                        <a>
                          <Icon type="delete" />
                        </a>
                      </Popconfirm>,
                    ]
                  }
                  author={strVal(cmt, 'owner.nickname')}
                  avatar={
                    get(cmt, 'owner.image')
                      ? `${streamUrl}files/${get(
                          cmt,
                          'owner.image'
                        )}?action=view&access_token=${this.auth.getAccessToken()}`
                      : Avatar2
                  }
                  content={strVal(cmt, 'comment.description')}
                  datetime={moment(strVal(cmt, 'comment.timestamp')).format('MMM Do YY, hh:mm:ss')}
                />
              )}
            />
          )}
        </Spin>
        <Form onSubmit={this.submit}>
          <Col span={22}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('text', {
                rules: [{ required: true, message: "Comment can't be empty" }],
              })(<Input style={{ width: '100%' }} placeholder="Add a Comment" />)}
            </FormItem>
          </Col>
          <Col span={2}>
            <FormItem {...tailFormItemLayout}>
              <Button
                type="primary"
                shape="circle"
                htmlType="submit"
                icon="plus"
                loading={this.state.loading}
              />
            </FormItem>
          </Col>
        </Form>
      </Card>
    )
  }
}

Comments.propTypes = {}
Comments.defaultProps = {}

export default compose(Form.create())(Comments)
